import React from "react";
import StepNavigation from "./StepNavigation";
import { useTranslation } from "react-i18next";
import { isOpenForForeignAllowed } from "../../utils/openForForeign";
import HomeButton from "../HomeButton";
import "../../styles/steps.css";

const TYPES = [
  { value: "apartment" },
  { value: "house" },
  { value: "country_house" },
  { value: "land" },
  { value: "commercial_space" },
  { value: "hotel" }
];


const TYPE_SUBTYPES = {

  apartment: ["studio", "penthouse","micro","condominium","basement","mansard","other"],
  house: ["villa", "cottage", "detached","townhouse", "contemporary", "condo", "other"],
  land: ["agricultural","non-agricultural","commercial","special","investment","farm", "other"],
  country_house: ["villa", "cottage", "detached","townhouse", "contemporary", "condo", "other"],
  commercial_space: ["special", "office", "trade","warehousing", "manufacturing", "food_object", "garage", "basement", "part_basement", "full_building","car_wash", "autoservice", "universal", "other"],
  hotel: ["resort","spa_hotel","suite_hotel", "bed_and_breakfast","boutique_hotel","motel", "hostel", "extended_stay", "other"],

};

export default function StepType({ listing, setListing, onNext }) {
  const { t } = useTranslation();
  const subtypes = TYPE_SUBTYPES[listing.type] || [];
 const isNextDisabled = !listing.type || !listing.subType || listing.subType.length === 0;
const MULTI_SUBTYPE_TYPES = ["apartment", "hotel"];

   return (
    <div className="step">
     <HomeButton/>
       <h2 className="step-title">{t("common.property_type")}</h2>

      <div className="option-grid">
        {TYPES.map(({ value }) => (
          <button
            key={value}
            type="button"
            className={`option-card ${
              listing.type === value ? "active" : ""
            }`}
            onClick={() =>
              setListing((l) => ({
                ...l,
                type: value,
                subType: [],
                openForForeign: isOpenForForeignAllowed(value, l.purpose)
                  ? l.openForForeign
                  : false,
              }))
            }
          >
            {t(`property.type.${value}`)}
          </button>
        ))}
      </div>

      {listing.type && (
        <>
          <h3 className="step-subtitle">
       {t("common.subtype")}{" "}
      {MULTI_SUBTYPE_TYPES.includes(listing.type) && (
  <span className="muted">
    {t("common.multiple_allowed")}
  </span>
)}
           </h3>

          <div className="option-grid small">
            {subtypes.map((sub) => (
              <button
                key={sub}
                type="button"
                className={`option-card ${
                  listing.subType?.includes(sub) ? "active" : ""
                }`}
                onClick={() =>
  setListing((l) => {
    const isMulti = MULTI_SUBTYPE_TYPES.includes(l.type);

    if (isMulti) {
      const exists = l.subType?.includes(sub);

      return {
        ...l,
        subType: exists
          ? l.subType.filter((s) => s !== sub) // remove
          : [...(l.subType || []), sub],      // add
      };
    } else {
      return {
        ...l,
        subType: [sub], // only one allowed
      };
    }
  })
}
              >
                {t(`property.subtype.${sub}`)}
              </button>
            ))}
          </div>
        </>
      )}

      <StepNavigation onNext={onNext} nextDisabled={isNextDisabled} />
    </div>
  );
}
